import React from "react"
import { Button, ListGroup, ListGroupItem, Container, Input } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { itemsFetchBalances } from "../../../store/actions/getVslaBalance"
import { memberLoaded } from "../../../store/actions/members/getMember"
import { fetchTransactionsAggreg } from "../../../store/actions/getMemberAggregates"
import { selectVlsaFundAccounts } from "../../../store/reducers/getVslas"
import { patchMemberHOL } from "../../../store/actions/updateMemberInfo"
import { toast } from "react-toastify"
import { select, t } from "@lingui/macro"
import { selectMemberReversedLoanPaidTrasactions } from "../../../store/reducers/getTransactions"
import { getMemberBalanceByMemberId } from "../../../store/reducers/transactions/actions"
import MultipleSelect from "../../layout/MulitpleSelect"
import PhoneInput from "react-phone-input-2"
import ar from "react-phone-input-2/lang/ar.json"
import "react-phone-input-2/lib/style.css"
import { defaultDate } from "../../../view/shared/utilities"
import { Label } from "reactstrap"
import { fetchVslasMembers } from "../../../store/actions/members/getVslaMembers"
import { setCurrentPage } from "../../../store/reducers/navigation"
import { deleteMemberAction } from "../../../store/actions/members/deleteMember"
import StellarLoader from "../../layout/StellarLoader"
import CustomModal from "../../layout/Modal"
import { Trans, useLingui } from "@lingui/react"
import styles from "./style.module.css"

let totalSHA = [0]
let totalSC = [0]

const SuccessMessage = () => {
  return (
    <div>
      <Trans id="notifications.edit_success">Edited successfully</Trans>
    </div>
  )
}

const ErrorMessage = () => {
  return (
    <div>
      <Trans id="notifications.edit_error">Error editing</Trans>
    </div>
  )
}

const notify = (msg) => toast.info(msg)

const Actions = (props) => {
  const { i18n } = useLingui()
  const {
    isLoading,
    user,
    vsla,
    setPage,
    meetingTransactions,
    isConnected,
    fetchMembers,
    fund_balance,
    currentMember,
    loadedvslaMembers,
    membersBalance,
    getAggregates,
    ongoingMeeting,
    patchMemberhol,
    availableAccounts,
    getMemberBalance,
    processingCashout,
    getUpdatedVslaBalance,
    reversedLoanRepaidTransaction,
    cashoutStarted,
    deleteUser,
    updateMemberInfo,
  } = props
  const [params, setParams] = React.useState({
    mem_id: currentMember?.id,
    vsla_id: vsla?.id,
    name: currentMember?.full_name,
  })
  const [isOpen, setIsOpen] = React.useState(false)
  const [modalInputData, setInputData] = React.useState()

  const [account, setAccount] = React.useState({
    loan: {
      assetType: "SC",
      balance: 0,
      accountType: "loan",
    },
    total_loan_interest: {
      assetType: "SC",
      balance: 0,
      accountType: "total_loan_interest",
    },
    paid_loan_interest: {
      assetType: "SC",
      balance: 0,
      accountType: "paid_loan_interest",
    },
    loan_interest: {
      assetType: "SC",
      balance: 0,
      accountType: "loan_interest",
    },
    welfare: {
      assetType: "SC",
      balance: 0,
      accountType: "welfare",
    },
    welfare_requests: {
      assetType: "SC",
      balance: 0,
      accountType: "welfare_requests",
    },
    savings: {
      assetType: "SC",
      balance: 0,
      accountType: "savings",
    },
    shares: {
      assetType: "SC",
      balance: 0,
      accountType: "shares",
    },
    "fine paid": {
      assetType: "SC",
      balance: 0,
      accountType: "fine paid",
    },
    membership: {
      assetType: "SC",
      balance: 0,
      accountType: "membership",
    },
  })

  React.useEffect(() => {
    if (!currentMember) {
      setPage("group-overview")
    }
    const memberId = currentMember?.pubkey
    const data = membersBalance[memberId]
    if (!data) {
      return
    }
    setAccount(data)
  }, [currentMember, membersBalance])

  const [isCreatingLoan, setCreatingLoan] = React.useState(false)
  const [isPayingFee, setServiceFeePayment] = React.useState(false)
  const [isPayingLoan, setLoanPayment] = React.useState(false)
  const [isRequestingWellFare, setRequestingWellFare] = React.useState(false)
  const [isSellingShares, setSellingShares] = React.useState(false)
  const [isWritingOffLoan, setWritingOffLoan] = React.useState(false)

  React.useEffect(() => {
    const ts = meetingTransactions
    let CR = []
    let LIR = []
    let LR = []
    let WFQ = []
    let WROff = []
    let SSH = []
    ts.forEach((item) => {
      const type = item.data ? item.data.type : item.transactionType
      if (type === "CREATE_LOAN" && item.status !== "SUCCESSFUL") {
        CR.push(type)
      } else if (
        type === "LOAN_INTEREST_REPAYMENT" &&
        item.status !== "SUCCESSFUL"
      ) {
        LIR.push(type)
      } else if (type === "LOAN_REPAYMENT" && item.status !== "SUCCESSFUL") {
        LR.push(type)
      } else if (type === "WELFARE_REQUEST" && item.status !== "SUCCESSFUL") {
        WFQ.push(type)
      } else if (type === "WRITE_OFF_LOAN" && item.status !== "SUCCESSFUL") {
        WROff.push(type)
      } else if (type === "SELL_SHARES" && item.status !== "SUCCESSFUL") {
        SSH.push(type)
      }
    })

    setCreatingLoan(CR.length > 0)
    setServiceFeePayment(LIR.length > 0)
    setLoanPayment(LR.length > 0)
    setRequestingWellFare(WFQ.length > 0)
    setSellingShares(SSH.length > 0)
    setWritingOffLoan(WROff.length > 0)
  }, [meetingTransactions])

  const secretary = t({ id: "Secretary" })
  const chairperson = t({ id: "Chairperson" })
  const box_keeper = t({ id: "Box Keeper" })
  const organizer = t({ id: "Organiser" })
  const money_counter = t({ id: "Money Counter" })
  const member = t({ id: "Member" })
  const female = t({ id: "Female" })
  const male = t({ id: "Male" })
  const gender = t({ id: "Gender" })
  const nationality = t({ id: "Nationality" })
  const select_nationality = t({ id: "Select Nationalities" })
  const member_phone = t({ id: "Phone number" })
  const member_name = t({ id: "Full name" })
  const keyHolder = t({ id: "Key Holder" })

  const [isEditing, setIsEditing] = React.useState(false)
  const [state, setState] = React.useState({
    pubkey: currentMember?.pubkey,
    phone: currentMember?.phone,
    full_name: currentMember?.full_name,
    date_of_birth: currentMember?.date_of_birth,
    member_role: currentMember?.member_role,
    gender: currentMember?.gender,
    nationalities: currentMember?.nationalities ? currentMember?.nationalities : [],
  })

  const [editButtonDisable] = React.useState(false)

  const fetchData = async () => {
    if (!isConnected) {
      return
    }

    Promise.all([getUpdatedVslaBalance(), getMemberBalance(params.mem_id)])
    getAggregates()
  }

  React.useEffect(() => {
    fetchData()
    fund_balance.forEach((f) => {
      if (f.asset === "SC") {
        totalSC.push(parseFloat(f.balance))
      }

      if (f.asset === "SHAR") {
        totalSHA.push(parseFloat(f.balance))
      }
    })
  }, [])

  React.useEffect(() => {
    setState({
      pubkey: currentMember?.pubkey,
      phone: currentMember?.phone,
      full_name: currentMember?.full_name,
      date_of_birth: currentMember?.date_of_birth,
      member_role: currentMember?.member_role,
      gender: currentMember?.gender,
      nationalities: currentMember?.nationalities
        ? currentMember?.nationalities
        : [],
    })
    if (!currentMember?.full_name) {
      return
    }
    setParams({ ...params, name: currentMember?.full_name })
  }, [currentMember])

  const balanceCheck = (params) => {
    return params.every((element) => element.balance === 0)
  }

  const deactivateDeleteBtn = () => {
    //if member can be deleted, enable delete button
    if (eligibleForDeletion()) {
      return false
    }
    return true
  }

  const eligibleForDeletion = () => {
    const balances = Object.values(account)
    //if member has balances, member cannot be deleted
    if (!balanceCheck(balances)) {
      return false
    }
    return true
  }

  const deleteMember = async () => {
    if (
      isConnected &&
      window.confirm(t({ id: `Are you sure you want to delete this member?` }))
    ) {
      const member = loadedvslaMembers.find(
        (member) => member.pubkey === currentMember?.pubkey,
      )

      //check if cashout in progress
      if (!["ar", "lb"].includes(i18n.locale) && cashoutStarted) {
        alert(t({ id: `Cannot delete member while cashout is in progress` }))
        return
      }

      //check if App secretary
      if (member.member_role === "Secretary") {
        alert(t({ id: `Cannot delete secretary` }))
        return
      }

      //delete member
      const data = {
        pubkey: member.pubkey,
        memberId: params.mem_id,
      }
      await deleteUser(member, data, member.id)
    }
  }

  const onChange = (e) => setState({ ...state, [e.target.name]: e.target.value })

  const toggleEditMember = () => setIsEditing(!isEditing)

  const updateMember = () => {
    const headers = {
      headers: { Authorization: "Bearer " + user.token },
    }
    patchMemberhol(
      `/members/${state.pubkey}`,
      {
        phone: state.phone,
        full_name: state.full_name,
        date_of_birth: state.date_of_birth,
        status: currentMember?.status,
        loan_service_charge: currentMember?.loan_service_charge,
        member_role: state.member_role,
        gender: state.gender,
        nationalities: state.nationalities,
      },
      headers,
    )
      .then((res) => {
        updateMemberInfo(res)
        fetchMembers()
        setIsEditing(false)
        notify(<SuccessMessage />)
      })
      .catch(() => {
        notify(<ErrorMessage />)
      })
  }

  const [canEdit, setCanEdit] = React.useState(false)

  React.useEffect(() => {
    setCanEdit(isConnected && !ongoingMeeting)
  }, [isConnected, ongoingMeeting])

  const enableMidCycleCashoutTab = React.useMemo(() => {
    if (!currentMember?.pubkey) {
      return false
    }
    const memId = params.mem_id
    const lang = i18n.locale
    const account = props.selectMemberAccount(currentMember.pubkey)
    if (!account) {
      return false
    }
    const { isOffline, balances } = account || {}
    if (isOffline) {
      return false
    }
    const hasPositiveBalance =
      balances?.savings?.balance > 0 ||
      balances?.["fine paid"]?.balance > 0 ||
      balances?.welfare?.balance > 0 ||
      balances?.membership?.balance > 0
    const shouldHide =
      !processingCashout(memId, params.vsla_id) &&
      hasPositiveBalance &&
      !ongoingMeeting?.cacheId &&
      !["ar", "lb"].includes(lang)

    return shouldHide
  }, [props.currentMember])

  const performMidCycleCashout = () => {
    setPage("group-cashOut")
  }
  return (
    <>
      {isLoading && <StellarLoader />}

      <div>
        <div>
          <h4 className={styles.header}>{currentMember?.full_name}</h4>
        </div>
        <Container className="list-group-flush">
          <ListGroup>
            <span
              onClick={() => {
                setPage("group-overview")
              }}
            >
              <ListGroupItem
                className={i18n.locale === "ar" ? styles.linkReverseStyles : ""}
              >
                <Trans id="member.overview">Overview</Trans>
                <FontAwesomeIcon className={styles.iconStyle} icon="angle-right" />
              </ListGroupItem>
            </span>

            {ongoingMeeting && (
              <div>
                <span
                  onClick={() => {
                    setPage("group-buyShares")
                  }}
                >
                  <ListGroupItem
                    className={i18n.locale === "ar" ? styles.linkReverseStyles : ""}
                  >
                    <span>
                      <Trans id="buy.shares">Buy Shares</Trans>
                    </span>
                    <FontAwesomeIcon
                      className={styles.iconStyle}
                      icon="angle-right"
                    />
                  </ListGroupItem>
                </span>
                {availableAccounts?.includes("welfare") &&
                  !["ar", "lb"].includes(i18n.locale) && (
                    <span
                      onClick={() => {
                        setPage("group-addWelfare")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                      >
                        <span>
                          <Trans id="welfare">Welfare</Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                  )}
                {availableAccounts?.includes("agri") &&
                  !["ar", "lb"].includes(i18n.locale) && (
                    <span
                      onClick={() => {
                        setPage("group-addAgri")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                      >
                        <span>
                          <Trans id="Add to Agricultural Fund">
                            Add to Agricultural Fund
                          </Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                  )}
                {availableAccounts?.includes("fine") &&
                  !["ar", "lb"].includes(i18n.locale) && (
                    <span
                      onClick={() => {
                        setPage("group-payFine")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                      >
                        <span>
                          <Trans id="Pay Fine">Pay Fine</Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                  )}
                {!["ar", "lb"].includes(i18n.locale) &&
                  account.loan.balance === 0 && (
                    <span
                      onClick={(e) => {
                        if (isCreatingLoan) {
                          e.preventDefault()
                          return
                        }
                        setPage("group-createLoan")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                        style={{ color: isCreatingLoan ? "grey" : "#000" }}
                      >
                        <span>
                          <Trans id="Create Loan">Create Loan</Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                  )}
                {account?.shares?.balance !== 0 && (
                  <span
                    onClick={(e) => {
                      if (isSellingShares) {
                        e.preventDefault()
                        return
                      }
                      setPage("group-sellShares")
                    }}
                  >
                    <ListGroupItem
                      className={
                        i18n.locale === "ar" ? styles.linkReverseStyles : ""
                      }
                      style={{ color: isSellingShares ? "grey" : "#000" }}
                    >
                      <span>
                        <Trans id="Sell Shares">Sell Shares</Trans>
                      </span>
                      <FontAwesomeIcon
                        className={styles.iconStyle}
                        icon="angle-right"
                      />
                    </ListGroupItem>
                  </span>
                )}
                {(account.loan.balance > 0 ||
                  reversedLoanRepaidTransaction.length > 0) &&
                  !["ar", "lb"].includes(i18n.locale) && (
                    <span
                      onClick={(e) => {
                        if (isPayingLoan || isPayingFee) {
                          e.preventDefault()
                          return
                        }
                        setPage("group-repayLoan")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                        style={{
                          color: isPayingLoan || isPayingFee ? "grey" : "#000",
                        }}
                      >
                        <span>
                          <Trans id="loan.repayment">Repay Loan</Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                  )}
                {availableAccounts?.includes("welfare") &&
                  !["ar", "lb"].includes(i18n.locale) && (
                    <span
                      onClick={(e) => {
                        if (isRequestingWellFare) {
                          e.preventDefault()
                          return
                        }
                        setPage("group-requestWelfare")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                        style={{
                          color: isRequestingWellFare ? "grey" : "#000",
                        }}
                      >
                        <span>
                          <Trans id="Welfare Request">Welfare Request</Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                  )}
                {availableAccounts?.includes("membership") &&
                  !["ar", "lb"].includes(i18n.locale) && (
                    <span
                      onClick={() => {
                        setPage("group-membershipFee")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                      >
                        <span>
                          <Trans id="Membership Fee">Membership Fee</Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                  )}
                {account.loan.balance > 0 && !["ar", "lb"].includes(i18n.locale) && (
                  <span
                    onClick={(e) => {
                      if (isWritingOffLoan) {
                        e.preventDefault()
                        return
                      }
                      setPage("group-writeOffLoan")
                    }}
                  >
                    <ListGroupItem
                      className={
                        i18n.locale === "ar" ? styles.linkReverseStyles : ""
                      }
                      style={{ color: isWritingOffLoan ? "grey" : "#000" }}
                    >
                      <span>
                        <Trans id="loan.write.off">Write-off Loan</Trans>
                      </span>
                      <FontAwesomeIcon
                        className={styles.iconStyle}
                        icon="angle-right"
                      />
                    </ListGroupItem>
                  </span>
                )}
                {!["ar", "lb"].includes(i18n.locale) && (
                  <>
                    <span
                      onClick={() => {
                        setPage("group-addGroupIncome")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                      >
                        <span>
                          <Trans id="title_copy.otherIncome">Other Income</Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                    <span
                      onClick={() => {
                        setPage("group-addGroupExpense")
                      }}
                    >
                      <ListGroupItem
                        className={
                          i18n.locale === "ar" ? styles.linkReverseStyles : ""
                        }
                      >
                        <span>
                          <Trans id="title_copy.otherExpenses">Other Expenses</Trans>
                        </span>
                        <FontAwesomeIcon
                          className={styles.iconStyle}
                          icon="angle-right"
                        />
                      </ListGroupItem>
                    </span>
                  </>
                )}
                {enableMidCycleCashoutTab && (
                  <span
                    onClick={() => {
                      setIsOpen(true)
                    }}
                    style={{ touchAction: "none", cursor: "pointer" }}
                  >
                    <ListGroupItem
                      className={
                        i18n.locale === "ar" ? styles.linkReverseStyles : ""
                      }
                    >
                      <span>
                        <Trans id="menu_mem.midCycle_Cashout">
                          Mid-cycle Cashout
                        </Trans>
                      </span>
                      <FontAwesomeIcon
                        className={styles.iconStyle}
                        icon="angle-right"
                      />
                    </ListGroupItem>
                  </span>
                )}
              </div>
            )}
          </ListGroup>
        </Container>
        {!ongoingMeeting && (
          <>
            <br />
            <div>
              <h6 className={styles.actionStyle}>
                <Trans id="Member Actions">Member Actions</Trans>
              </h6>
            </div>
            <Container>
              {isEditing && (
                <>
                  <span
                    style={{
                      direction: "ltr",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Label
                      style={{
                        alignSelf: i18n.locale === "ar" ? "end" : "initial",
                      }}
                    ></Label>
                    <PhoneInput
                      country="ne"
                      enableSearch
                      disableSearchIcon
                      placeholder={member_phone}
                      inputStyle={{
                        flex: "10",
                        fontFamily: "Roboto",
                        height: "50px",
                        width: "100%",
                        fontSize: "1.25rem",
                      }}
                      name="phone"
                      onChange={(phone) => setState({ ...state, phone })}
                      value={state.phone}
                      limitMaxLength={true}
                      localization={i18n.locale === "ar" ? ar : false}
                    />
                  </span>
                  <Input
                    type="text"
                    name="full_name"
                    className={styles.inputStyle}
                    placeholder={member_name}
                    onChange={onChange}
                    value={state.full_name}
                  />

                  <Input
                    type="date"
                    name="date_of_birth"
                    placeholder="date_of_birth"
                    selected={state.date_of_birth}
                    className={styles.formStyle}
                    style={{ margin: "8px 0" }}
                    onChange={onChange}
                    defaultValue={state.date_of_birth}
                    numberofmonths={1}
                    max={defaultDate()}
                  />
                  <Input
                    id="select_role"
                    type="select"
                    name="member_role"
                    className={styles.formStyle}
                    onChange={onChange}
                    value={state.member_role}
                  >
                    <option>{secretary}</option>
                    <option>{chairperson}</option>
                    <option>{box_keeper}</option>
                    <option>{organizer}</option>
                    <option>{money_counter}</option>
                    <option>{member}</option>
                    <option>{keyHolder}</option>
                  </Input>

                  {["ar", "lb"].includes(i18n.locale) && (
                    <MultipleSelect
                      title={nationality}
                      preSetItems={state.nationalities}
                      callback={(items) => {
                        setState({ ...state, nationalities: items })
                      }}
                      placeholderOption={select_nationality}
                      options={[
                        {
                          value: "Lebanon",
                          title: "Lebanon",
                        },
                        {
                          value: "Syria",
                          title: "Syria",
                        },
                        {
                          value: "Palestine",
                          title: "Palestine",
                        },
                      ]}
                    />
                  )}
                  <Input
                    id="gender"
                    type="select"
                    name="gender"
                    className={styles.formStyle}
                    style={{ margin: "8px 0" }}
                    onChange={onChange}
                    value={state.gender?.toLocaleLowerCase() || null}
                  >
                    <option disabled value="">
                      {gender}
                    </option>
                    <option value="female">{female}</option>
                    <option value="male">{male}</option>
                  </Input>
                  <br />
                  <Button
                    className="btn btn-primary"
                    onClick={updateMember}
                    size="sm"
                    color="primary"
                    block
                    disabled={editButtonDisable}
                  >
                    <Trans id="save">Save</Trans>
                  </Button>
                </>
              )}
              {!isEditing && (
                <Button
                  className="btn btn-primary"
                  onClick={toggleEditMember}
                  size="sm"
                  color="primary"
                  block
                  disabled={!canEdit}
                >
                  <Trans id="Edit Member">Edit Member</Trans>
                </Button>
              )}
              <Button
                className="btn btn-danger"
                onClick={deleteMember}
                size="sm"
                block
                disabled={deactivateDeleteBtn()}
                style={{ marginTop: "10px" }}
              >
                <Trans id="Delete Member">Delete Member</Trans>
              </Button>
            </Container>{" "}
          </>
        )}
      </div>
      <CustomModal
        modalHeader={t({ id: `Warning` })}
        headerClassName="d-flex justify-content-center"
        bodyContent={
          <div>
            {t({
              id: `Warning: This will cash out all the member's funds from the group. This action cannot be undone.`,
            })}
            <br />
            <br />
            <Trans
              id="To proceed, type &quot;{confirmWord}&quot; in the box below and click continue"
              values={{ confirmWord: <Trans id="Cashout">Cashout</Trans> }}
            />
          </div>
        }
        isCentered={true}
        showInput={true}
        errors={{}}
        showSavingsCycle={false}
        isCashoutModal={true}
        setInputData={setInputData}
        isOpen={isOpen}
        footerContent={
          <div className="btn-toolbar">
            <button
              className={styles.backButton}
              onClick={() => {
                setIsOpen(false)
              }}
            >
              <Trans id="Back">Back</Trans>
            </button>
            <button
              className={styles.continueButton}
              onClick={() => performMidCycleCashout()}
              disabled={!(modalInputData && modalInputData.toLowerCase() === i18n._({id: "Cashout", message: "Cashout"}).toLowerCase())}
            >
              <Trans id="Continue">Continue</Trans>
            </button>
          </div>
        }
      />
    </>
  )
}

Actions.propTypes = {
  isLoading: PropTypes.bool,
  user: PropTypes.object,
  vsla: PropTypes.object,
  setPage: PropTypes.func,
  meetingTransactions: PropTypes.array,
  isConnected: PropTypes.bool,
  fetchMembers: PropTypes.func,
  fund_balance: PropTypes.array,
  currentMember: PropTypes.object,
  loadedvslaMembers: PropTypes.array,
  membersBalance: PropTypes.object,
  getAggregates: PropTypes.func,
  ongoingMeeting: PropTypes.array,
  patchMemberhol: PropTypes.func,
  availableAccounts: PropTypes.array,
  getMemberBalance: PropTypes.func,
  processingCashout: PropTypes.func,
  getUpdatedVslaBalance: PropTypes.func,
  reversedLoanRepaidTransaction: PropTypes.array,
  cashoutStarted: PropTypes.bool,
  deleteUser: PropTypes.func,
  updateMemberInfo: PropTypes.func,
}

const mapStateToProps = (state) => {
  const { account, accountV2, loadedMember, loadedvslaMembers } = state

  // This selector now uses the pubkey to find the correct member account object.
  const selectMemberAccount = (pubkey) => {
    if (!pubkey) return null

    // Priority 1: Check for an offline balance using the pubkey.
    if (accountV2.offline?.members[pubkey]) {
      return { isOffline: true, balances: accountV2.offline.members[pubkey] }
    }

    if (account.members[pubkey]) {
      return { isOffline: false, balances: account.members[pubkey] }
    }

    return null // No balance found.
  }

  // The entire membersBalance object is now constructed based on the offline/online state
  const selectMembersBalance = () => {
    if (accountV2.offline) {
      return accountV2.offline.members
    }
    return account.members
  }

  return {
    user: state.user,
    isConnected: state.isConnected,
    currentPage: state.currentPage,
    vsla: state.vsla,
    meetingTransactions: state.meetingTransactions.filter(({ requestId }) =>
      requestId?.includes(state.loadedMember?.pubkey),
    ),
    pendingTransactions: state.pendingTransactions,
    pendingTransactionsKeys: Object.keys(state.pendingTransactions).filter((key) => {
      const fractions = key.split("_")
      return fractions.length >= 3 && fractions.includes(state.vsla?.id)
    }),
    pendingKeys: Object.keys(state.pendingTransactions)
      .filter((key) => {
        const fractions = key.split("_")
        return fractions.length >= 3 && fractions.includes(state.vsla?.id)
      })
      .map((key) => {
        const fractions = key.split("_")
        return `${fractions[fractions.length - 2]}_${
          fractions[fractions.length - 1]
        }`
      }),
    processingCashout: (memId, vslaId) =>
      state.pendingTransactions[`${vslaId}_${memId}_cashout`],
    isLoading: state.memberBalanceLoadStarted,
    isLoadingMember: state.memberLoadingStarted,
    fund_balance: state.memberBalanceLoaded,
    ongoingMeeting: state.meeting?.ongoing,
    currentMember: loadedMember,
    loadedvslaMembers: loadedvslaMembers,
    membersBalance: selectMembersBalance(),
    availableAccounts: selectVlsaFundAccounts(state),
    reversedLoanRepaidTransaction: selectMemberReversedLoanPaidTrasactions(state),
    cashoutStarted: state.cashoutStarted,
    selectMemberAccount: selectMemberAccount
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(setCurrentPage(page)),
    getMemberBalance: (id) => dispatch(getMemberBalanceByMemberId(id)),
    getUpdatedVslaBalance: () => dispatch(itemsFetchBalances()),
    getAggregates: () => dispatch(fetchTransactionsAggreg()),
    patchMemberhol: (url, data, headers) =>
      dispatch(patchMemberHOL(url, data, headers)),
    fetchMembers: () => dispatch(fetchVslasMembers()),
    updateMemberInfo: (data) => dispatch(memberLoaded(data)),
    deleteUser: (member, data, vsla_id) =>
      dispatch(deleteMemberAction(member, data, vsla_id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Actions)
